module.exports = __webpack_public_path__ + "img/75746F_333330_A2A1A9_444444-256px.0d293b6d.png";